// 생성 파일 — 손으로 고치지 않는다. 원문 `tools/policy-sources/privacy-2026-09-18.html`, 변환 `tools/make-policy-docs.py`.
import type { PolicyDoc } from '../../policyDoc';

export const privacy20260918Ko: PolicyDoc = {
  articles: [
    {
      title: '제1조 (처리하는 개인정보 항목 및 수집 방법)',
      blocks: [
        {
          type: 'p',
          text: '회사는 회원가입 없이(무로그인) 서비스를 제공하며, 서비스 제공에 필요한 최소한의 정보만을 수집합니다.',
        },
        {
          type: 'sub',
          text: '가. 이용자가 직접 제공하는 정보',
        },
        {
          type: 'table',
          head: ['구분', '항목', '수집 시점'],
          rows: [
            [
              '음성 녹음 데이터',
              '발성·노래 녹음 파일(음성)',
              '음성 측정 기능 이용 시',
            ],
            [
              '음향 분석 결과',
              '음역대, 기본주파수(F0), 포먼트(F1~F3), HNR, 발성 안정도 등 측정 수치',
              '분석 처리 시 자동 생성',
            ],
            [
              '설문 응답',
              '온보딩 시 이용자가 선택 입력하는 발성 목적·경험 등(선택 항목, 건너뛰기 가능)',
              '온보딩 이용 시',
            ],
          ],
        },
        {
          type: 'sub',
          text: '나. 서비스 이용 과정에서 자동으로 생성·수집되는 정보',
        },
        {
          type: 'ul',
          items: [
            '기기 정보: 기기 모델, 운영체제(OS) 버전, 앱 버전, 마이크 하드웨어 식별 정보(음향 편차 보정 목적)',
            '이용 기록: 접속 로그, 서비스 이용 기록, 오류(크래시) 로그',
            '비식별 기기 식별자: 리포트 누적 및 이용자 구분을 위해 앱이 자체 생성하는 식별자(계정 정보 아님)',
          ],
        },
        {
          type: 'sub',
          text: '다. 수집 방법',
        },
        {
          type: 'p',
          text: '앱 내 음성 측정·온보딩 화면을 통한 이용자 입력, 서비스 이용 과정에서의 자동 생성·수집',
        },
        {
          type: 'note',
          text: '※ 음성 녹음은 이용자가 측정 버튼을 눌러 명시적으로 녹음을 시작한 경우에만 수집되며, 마이크 권한은 측정 기능 외의 목적으로 사용되지 않습니다. 이용자는 기기 설정에서 언제든지 마이크 권한을 해제할 수 있으며, 이 경우 음성 측정 기능 이용이 제한됩니다.',
        },
      ],
    },
    {
      title: '제2조 (음성 데이터에 관한 특칙)',
      blocks: [
        {
          type: 'p',
          text: '회사는 음성 데이터의 민감성을 고려하여 다음 원칙을 적용합니다.',
        },
        {
          type: 'ol',
          items: [
            '수집 목적 한정: 음성 녹음은 발성·음향 특성의 측정 및 분석 목적으로만 이용되며, 특정 개인을 식별·인증하는 목적(화자 인식)으로는 이용하지 않습니다.',
            '처리 방식: 녹음 파일은 분석 서버로 전송되어 음향 수치로 변환되며, 변환 결과(수치)는 이용자의 리포트 누적을 위해 저장됩니다.',
            '보관 및 삭제: 원본 음성 녹음 파일은 분석 완료 후 12개월 이내에 자동 파기하며, 이용자가 데이터 삭제를 요청하는 경우 지체 없이 파기합니다. 측정 수치는 삭제 요청 전까지 리포트 제공을 위해 보관합니다.',
            '모델 학습 이용 시 별도 동의: 회사가 음성 데이터를 서비스 품질 개선(AI 분석 모델 학습 등)에 이용하고자 하는 경우, 이용자로부터 사전에 선택적(옵트인) 동의를 받습니다. 동의하지 않아도 기본 서비스 이용에는 제한이 없으며, 동의한 경우에도 언제든지 철회할 수 있습니다.',
          ],
        },
        {
          type: 'note',
          text: '※ 회사는 음성 데이터를 특정 개인을 식별하는 목적(화자 식별)으로 처리하지 않으므로, 「개인정보 보호법」상 생체인식정보로 처리하지 않습니다.',
        },
      ],
    },
    {
      title: '제3조 (개인정보의 처리 목적)',
      blocks: [
        {
          type: 'ul',
          items: [
            '음성 측정·분석 및 결과 리포트 생성·누적 제공',
            '서비스 제공, 유지·개선 및 신규 기능 개발',
            '기기·마이크별 음향 편차 보정 등 측정 정확도 향상',
            '오류·부정 이용 대응 및 서비스 안정성 확보',
            '법령상 의무 이행 및 이용자 문의 응대',
          ],
        },
        {
          type: 'p',
          text: '회사는 위 목적 이외의 용도로 개인정보를 이용하지 않으며, 이용 목적이 변경되는 경우 「개인정보 보호법」에 따라 별도의 동의를 받는 등 필요한 조치를 이행합니다.',
        },
      ],
    },
    {
      title: '제4조 (개인정보의 처리 및 보유 기간)',
      blocks: [
        {
          type: 'table',
          head: ['항목', '보유 기간'],
          rows: [
            ['원본 음성 녹음 파일', '분석 완료 후 12개월 이내 파기'],
            [
              '음향 분석 수치·리포트',
              '이용자의 삭제 요청 또는 서비스 이용 종료 시까지',
            ],
            ['설문 응답', '이용자의 삭제 요청 또는 서비스 이용 종료 시까지'],
            ['서비스 이용·접속 로그', '3개월'],
          ],
        },
        {
          type: 'p',
          text: '관계 법령에 따라 보존할 의무가 있는 경우에는 해당 법령에서 정한 기간 동안 보관한 후 파기합니다.',
        },
      ],
    },
    {
      title: '제5조 (개인정보의 제3자 제공)',
      blocks: [
        {
          type: 'p',
          text: '회사는 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만 법령에 특별한 규정이 있거나 수사기관이 법령에 정해진 절차와 방법에 따라 요청하는 경우는 예외로 합니다.',
        },
      ],
    },
    {
      title: '제6조 (개인정보 처리업무의 위탁)',
      blocks: [
        {
          type: 'p',
          text: '회사는 원활한 서비스 제공을 위해 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.',
        },
        {
          type: 'table',
          head: ['수탁자', '위탁 업무', '처리 장소'],
          rows: [
            [
              'Amazon Web Services, Inc.',
              '데이터 저장·인프라 운영(DB·스토리지)',
              'AWS 아시아 태평양(서울) 리전(ap-northeast-2), 대한민국',
            ],
            [
              'Amazon Web Services, Inc.',
              '음성 분석 서버 처리·연산',
              'AWS 아시아 태평양(서울) 리전(ap-northeast-2), 대한민국',
            ],
          ],
        },
        {
          type: 'p',
          text: '회사는 위탁계약 체결 시 「개인정보 보호법」 제26조에 따라 위탁업무 수행 목적 외 개인정보 처리 금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지 감독합니다. 위탁업무의 내용이나 수탁자가 변경될 경우 지체 없이 본 개인정보처리방침을 통하여 공개합니다.',
        },
      ],
    },
    {
      title: '제7조 (개인정보의 국외 이전)',
      blocks: [
        {
          type: 'p',
          text: '회사는 이용자의 개인정보를 국외로 이전하지 않습니다. 회사가 이용하는 클라우드 인프라(Amazon Web Services)는 아시아 태평양(서울) 리전(ap-northeast-2)에 위치하며, 이용자의 개인정보는 대한민국 내에서 저장·처리됩니다.',
        },
        {
          type: 'p',
          text: '향후 국외 이전이 필요한 경우에는 「개인정보 보호법」에 따라 이전받는 자, 이전 국가, 이전 항목 등을 사전에 고지하고 동의를 받는 등 필요한 절차를 거칩니다.',
        },
      ],
    },
    {
      title: '제8조 (개인정보의 파기 절차 및 방법)',
      blocks: [
        {
          type: 'ul',
          items: [
            '파기 절차: 보유 기간이 경과하거나 처리 목적이 달성된 개인정보는 지체 없이 파기합니다.',
            '파기 방법: 전자적 파일 형태의 정보는 복구·재생이 불가능한 방법으로 영구 삭제하며, 음성 원본 파일은 저장소에서 완전히 삭제합니다.',
          ],
        },
      ],
    },
    {
      title: '제9조 (정보주체와 법정대리인의 권리·의무 및 행사 방법)',
      blocks: [
        {
          type: 'ol',
          items: [
            '이용자는 언제든지 자신의 개인정보에 대해 열람·정정·삭제·처리정지 및 동의 철회를 요청할 수 있습니다.',
            "권리 행사는 앱 내 '데이터 삭제' 기능 또는 제13조의 연락처(이메일·전화)를 통해 할 수 있으며, 회사는 지체 없이 조치합니다.",
            '무로그인 서비스 특성상 회사는 본인 확인이 가능한 범위(앱이 생성한 기기 식별자 등)에서 요청을 처리합니다.',
            '권리 행사는 이용자의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 할 수도 있습니다.',
            '다른 법령에서 해당 개인정보의 보존을 요구하는 경우에는 그 삭제를 요구할 수 없습니다.',
          ],
        },
      ],
    },
    {
      title: '제10조 (개인정보의 안전성 확보 조치)',
      blocks: [
        {
          type: 'ul',
          items: [
            '전송 구간 암호화(HTTPS/TLS) 적용',
            '음성·개인정보에 대한 접근 권한 최소화 및 접근 통제',
            '개인정보 처리 기록 보관 및 접근 로그 관리',
          ],
        },
      ],
    },
    {
      title: '제11조 (개인정보 자동 수집 장치의 설치·운영 및 거부)',
      blocks: [
        {
          type: 'p',
          text: '회사는 웹사이트(muzly.io) 이용 시 서비스 제공에 필요한 범위에서 쿠키(cookie)를 사용할 수 있습니다. 이용자는 웹 브라우저의 설정을 통해 쿠키 저장을 거부할 수 있으며, 이 경우 일부 기능 이용에 제한이 있을 수 있습니다.',
        },
        {
          type: 'p',
          text: '회사는 맞춤형 광고를 목적으로 행태정보를 수집하지 않으며, 이용자를 다른 회사의 앱·웹사이트에 걸쳐 추적하지 않습니다.',
        },
      ],
    },
    {
      title: '제12조 (만 14세 미만 아동의 개인정보)',
      blocks: [
        {
          type: 'p',
          text: '회사는 만 14세 미만 아동의 개인정보를 수집하지 않는 것을 원칙으로 합니다. 만 14세 미만 아동의 개인정보가 수집된 사실이 확인된 경우 해당 정보를 지체 없이 파기합니다.',
        },
      ],
    },
    {
      title: '제13조 (개인정보 보호책임자 및 열람청구 접수 부서)',
      blocks: [
        {
          type: 'p',
          text: '회사는 개인정보 처리에 관한 업무를 총괄하여 책임지고, 이용자의 불만 처리 및 피해 구제와 열람청구 접수·처리를 위해 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.',
        },
        {
          type: 'table',
          head: ['구분', '내용'],
          rows: [
            ['개인정보 보호책임자', '황선엽 (대표)'],
            ['연락처(이메일)', 'support@muzly.io'],
            ['연락처(전화)', '02-2203-8636'],
            [
              '주소',
              '서울특별시 송파구 위례성대로16길 9, 6층 (방이동, 지엘빌딩)',
            ],
          ],
        },
      ],
    },
    {
      title: '제14조 (권익침해 구제 방법)',
      blocks: [
        {
          type: 'p',
          text: '이용자는 개인정보 침해로 인한 구제를 받기 위하여 아래 기관에 분쟁 해결이나 상담 등을 신청할 수 있습니다.',
        },
        {
          type: 'ul',
          items: [
            '개인정보분쟁조정위원회 (www.kopico.go.kr / 1833-6972)',
            '개인정보침해신고센터 (privacy.kisa.or.kr / 118)',
            '대검찰청 (www.spo.go.kr / 1301)',
            '경찰청 (ecrm.police.go.kr / 182)',
          ],
        },
      ],
    },
    {
      title: '제15조 (개인정보처리방침의 변경)',
      blocks: [
        {
          type: 'p',
          text: '본 개인정보처리방침의 내용 추가·삭제·수정이 있을 경우 시행 최소 7일 전에 앱 또는 웹사이트를 통해 공지합니다. 다만 이용자 권리에 중요한 변경이 있는 경우에는 최소 30일 전에 공지합니다.',
        },
        {
          type: 'ul',
          items: ['공고일자: 2026년 9월 18일', '시행일자: 2026년 9월 18일'],
        },
      ],
    },
    {
      title: '사업자 정보',
      blocks: [
        {
          type: 'table',
          head: ['구분', '내용'],
          rows: [
            ['상호', '뮤즐리 주식회사 (MUZLY Co.,Ltd.)'],
            ['대표자', '황선엽'],
            ['사업자등록번호', '876-81-03932'],
            [
              '주소',
              '서울특별시 송파구 위례성대로16길 9, 6층 (방이동, 지엘빌딩)',
            ],
            ['이메일', 'support@muzly.io'],
            ['전화번호', '02-2203-8636'],
          ],
        },
      ],
    },
  ],
  title: '뮤즐리 개인정보처리방침',
  intro:
    '뮤즐리 주식회사(이하 "회사")는 「개인정보 보호법」 등 관련 법령을 준수하며, 이용자의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리하기 위해 다음과 같이 개인정보처리방침을 수립·공개합니다. 본 방침은 회사가 운영하는 모바일 애플리케이션 \'MUZLY(뮤즐리)\'(이하 "앱") 및 관련 웹사이트(muzly.io)에 적용됩니다.',
  summary: [
    {
      label: '이용자가 직접 제공하는 정보',
      value: '음성 녹음 데이터, 음향 분석 결과, 설문 응답',
    },
    {
      label: '서비스 이용 과정에서 자동으로 생성·수집되는 정보',
      value: '기기 정보, 이용 기록, 비식별 기기 식별자',
    },
  ],
};
